import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-picture-upload',
  standalone: true,
  imports: [],
  templateUrl: './picture-upload.component.html',
  styleUrl: './picture-upload.component.scss'
})
export class PictureUploadComponent {
  @Input()
  pictureUrl: string | null = null;

  @Input()
  fileExtensions?: string[];

  @Input()
  fileMaxSize?: number;

  @Output() upload: EventEmitter<File> = new EventEmitter<File>();
  @Output() error: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('fileInput', {static: true}) fileInput!: ElementRef<HTMLInputElement>;

  protected picturePreviewUrl: string | null = null;

  constructor(
    private readonly translate: TranslateService
  ) {}

  protected onChanged(event: Event) {
    const element = event.target as HTMLInputElement;
    const file = element.files?.[0];

    if (!file) {
      return;
    }

    const fileExtension = file.name.split('.').pop()?.toLowerCase();

    if (this.fileExtensions && (!fileExtension || !this.fileExtensions.includes(`.${fileExtension}`))) {
      this.error.emit(this.translate.instant('messages.invalid_file'));
      return;
    }

    if (this.fileMaxSize && file.size > this.fileMaxSize) {
      this.error.emit(this.translate.instant('messages.file_too_large', { size: Math.round(this.fileMaxSize / 1024 / 1024) }));
      return;
    }

    this.picturePreviewUrl = URL.createObjectURL(file);
    this.pictureUrl = this.picturePreviewUrl;
    this.upload.emit(file);

    element.value = '';
  }

  protected onPictureLoad(): void {
    if (this.picturePreviewUrl) {
      URL.revokeObjectURL(this.picturePreviewUrl);
    }
  }

  public selectFile(): void {
    this.fileInput.nativeElement.click();
  }

  public reset(): void {
    this.fileInput.nativeElement.value = '';
    this.picturePreviewUrl = null;
    this.pictureUrl = null;
  }
}
